import * as quote from './quote';
import * as address from './address';
import * as beneficiary from './beneficiary';
import * as externalAccess from './externalAccess';
import * as purchase from './purchase';
import * as ticket from './ticket';

export default {
    ...ticket,
    ...externalAccess,
    ...address,
    ...purchase,
    ...beneficiary,
    ...quote,
};
